<template>
    <div class="gifting-reminder">
        <img class="gifting-reminder--emblem gifting-reminder--emblem--right" src="~@/assets/images/decoration/embellishment-right.svg" alt="emblem-logo">
        <img class="gifting-reminder--emblem gifting-reminder--emblem--left" src="~@/assets/images/decoration/embellishment-left.svg" alt="emblem-logo">

        <div class="gifting-reminder--heading">
            <h1 class="gifting-reminder--title">{{ $t('GIFTING_REMINDERS_TITLE') }}</h1>
            <p class="gifting-reminder--paragraph-container gifting-reminder--paragraph">{{ $t('GIFTING_REMINDERS_PARAGRAPH') }}</p>
        </div>

        <div v-if="!specialDatesCouponRedeemed" class="gifting-reminder--banner" :class="{'banner-container' : specialDates && specialDates.length < 3}">
            <img class="gifting-reminder--banner--img" src="~@/assets/images/logos/gifting-reminder-vase.svg" alt="gifting-reminder-banner">
            <p class="gifting-reminder--banner--text">{{bannerCopy}}</p>
        </div>

        <div v-if="hasGiftReminder" class="gifting-reminder--grid-container">
            <div class="gifting-reminder--grid-layout">
                <gifting-reminders-card v-for="(item, index) in specialDates" :key="index" :item="item"/>
                <add-gifting-reminders-card v-if="hasEvenGiftReminders" @toggle="toggleAddGiftModal"/>
            </div>
        </div>

        <add-gifting-reminders-card v-if="!hasGiftReminder || !hasEvenGiftReminders" :customStyle="customStyle" @toggle="toggleAddGiftModal"/>

        <div class="gifting-reminder--button-container">
            <button  class="btn btn--green gifting-reminder--button" :class="{'gifting-reminder--secondary-black': hasGiftReminder}" @click="showAddGiftModal=true">+ {{$t("GIFTING_REMINDERS_ADD_A_NEW_DATE")}}</button>
            <button class="btn btn--green gifting-reminder--button" :class="{'gifting-reminder--disabled-button': !hasGiftReminder}" @click="showSendGiftModal=true">{{$t("GIFTING_REMINDERS_SEND_GIFT")}}</button>
        </div>

        <add-date-modal
            v-if="showAddGiftModal"
            @closed="toggleAddGiftModal"></add-date-modal>

        <send-gift-modal
            v-if="showSendGiftModal"
            @closed="toggleSendGiftModal"></send-gift-modal>

    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import GiftingRemindersCard from '@/components/partials/account/GiftingRemindersCard.vue';
import AddGiftingRemindersCard from '@/components/partials/account/AddGiftingRemindersCard.vue';
import AddDateModal from '@/components/partials/account/special-dates/AddDateModal';
import SendGiftModal from '@/components/partials/account/special-dates/SendGiftModal';

export default {
    name: 'GiftingReminders',
    components: {
        AddGiftingRemindersCard,
        GiftingRemindersCard,
        AddDateModal,
        SendGiftModal,
    },
    data() {
        return {
            showAddGiftModal: false,
            showSendGiftModal: false,
            window: {
                width: 0,
                mobileBreakpoint: 768,
            },
        };
    },
    mounted() {
        if (!this.specialDatesEnabled) this.$router.push({ name: '404' });
        this.$store.dispatch('specialDates/getAllSpecialDates');
        this.$store.dispatch('specialDates/getAllOccasionTypes');
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
    },
    computed: {
        ...mapGetters({
            specialDates: 'specialDates/getSpecialDates',
            specialDatesEnabled: 'account/getSpecialDatesEnabled',
            specialDatesCoupon: 'account/getSpecialDatesCoupon',
        }),
        hasGiftReminder() {
            return this.specialDates.length !== 0;
        },
        hasEvenGiftReminders() {
            return this.hasGiftReminder && this.specialDates.length % 2 !== 0;
        },
        isMobile() {
            return this.window.width < this.window.mobileBreakpoint;
        },
        customStyle() {
            return this.isMobile ? {
                width: '327px',
                height: '101px',
                marginTop: '20px',
            } : {
                width: '728px',
                height: '101px',
                marginTop: '20px',
            };
        },
        specialDatesCouponRedeemed() {
            return this.specialDatesCoupon?.special_dates_gifting_coupon_redeemed;
        },
        bannerCopy() {
            return this.specialDates.length >= 3 ? this.$t('GIFTING_REMINDERS_BANNER_TEXT_ADDED_DATES') : this.$t('GIFTING_REMINDERS_BANNER_TEXT');
        },
    },
    methods: {
        toggleAddGiftModal() {
            return this.showAddGiftModal = !this.showAddGiftModal;
        },
        toggleSendGiftModal() {
            return this.showSendGiftModal = !this.showSendGiftModal;
        },
        handleResize() {
            this.window.width = window.innerWidth;
        },
    },
};
</script>

<style lang="scss" scoped>
    .gifting-reminder {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        padding: 24px;
        min-width: 375px;

        &--emblem {
            position: absolute;
            z-index: 1;
            height: 249px;
            width: 141px;
            bottom: 0;
            &--right {
                right: 10px;
                top: 75px;
            }
            &--left {
                left: 0;
                top: 45px;
            }
        }

        &--heading {
            max-width: 327px;
            margin-bottom: 10px;
        }

        &--title {
            margin-top: 38px;
            font-size: 32px;
            align-self: flex-start;
        }

        &--paragraph {
            font-size: 16px;
            font-weight: 300;
            line-height: 22.5px;
        }

        &--banner {
            display: flex;
            justify-content: space-around;
            align-items: center;
            padding: 16px;
            max-width: 327px;
            background: #F4F8F0;
            border-radius: 3px;
            margin-bottom: 16px;

            &--img {
                height: 20px;
                width: 12px;
                left: 6px;
                top: 2px;
                border-radius: 0px;
            }
            &--text {
                font-size: 14px;
                line-height: 21px;
                font-weight: 400;
                color: #52755c;
                margin-left: 10px;
            }
        }

        &--grid-layout {
            display: grid;
            justify-content: center;
            align-items: center;
            gap: 1rem;
            grid-template-columns: 327px;
            max-height: 450px;
            overflow-y: scroll;
        }

        &--button-container {
            display: flex;
            flex-direction: column;
            margin-top: 56px;
        }

        &--button {
            min-width: 327px;
        }

        &--disabled-button {
            min-width: 327px;
            background: #F7F7F7;
            color: #CECECE;
        }

        &--secondary-black {
            border-color: #000;
            background-color: #fff;
            border-width: 2px;
            color: #000;
            border-style: solid;
            padding-top: 0.4rem;
            padding-bottom: 0.4rem;
            margin-bottom: 20px;
        }

        @media (min-width: 1024px){
            .gifting-reminder {
                min-width: 728px;
            }

            &--heading {
                min-width: 728px;
            }

            &--title {
                font-size: 52px;
                line-height: 64px;
                font-weight: 400;
            }

            &--paragraph {
                font-size: 20px;
                font-weight: 300;
                line-height: 25px;
            }

            &--paragraph-container {
                max-width: 663px;
            }

            &--banner {
                min-width: 728px;
                justify-content: flex-start;
                margin-top: 40px;
                margin-bottom: 64px;
                &--img {
                    width: 40px;
                    height: 54px;
                    margin-left: 40px;
                }
                &--text {
                    margin-left: 20px;
                }
            }

            &--grid-container{
                max-width: 752px;
            }

            &--grid-layout{
                display: grid;
                gap: 1rem;
                grid-template-columns: 352px 352px;
            }

            &--button-container {
                flex-direction: row;
                align-items: center;
                margin-top: 64px;
            }

            &--button {
                min-width: 352px;
            }

            &--disabled-button {
                margin-left: 24px;
                min-width: 352px;
            }

            &--secondary-black {
                margin-right: 20px;
                margin-bottom: 0px;
            }
        }

        @media (min-width: 768px){
            .gifting-reminder {
                min-width: 728px;
            }

            &--heading {
                min-width: 728px;
            }

            &--title {
                font-size: 52px;
                line-height: 64px;
                font-weight: 400;
            }

            &--paragraph {
                font-size: 20px;
                font-weight: 300;
                line-height: 25px;
            }

            &--paragraph-container {
                max-width: 663px;
            }

            &--banner {
                min-width: 728px;
                justify-content: flex-start;
                margin-top: 40px;
                margin-bottom: 64px;
                &--img {
                    width: 40px;
                    height: 54px;
                    margin-left: 40px;
                }
                &--text {
                    margin-left: 20px;
                }
            }

            &--grid-container{
                max-width: 752px;
            }

            &--grid-layout{
                display: grid;
                gap: 1rem;
                grid-template-columns: 352px 352px;
            }

            &--button-container {
                flex-direction: row;
                align-items: center;
                margin-top: 64px;
            }

            &--button {
                min-width: 352px;
            }

            &--disabled-button {
                margin-left: 24px;
                min-width: 352px;
            }

            &--secondary-black {
                margin-right: 20px;
                margin-bottom: 0px;
            }
        }

        @media (max-width: 930px){
            &--emblem {
                height: 215px;
                width: 125px;
                &--left {
                    display: none;
                }
                &--right {
                    top: 35px;
                }
            }

            &--disabled-button {
                margin-top: 16px;
            }
        }
    }

    @media only screen and (min-width: 380px){
        .banner-container {
            min-width: 327px;
        }
    }

    @media only screen and (min-width : 768px) {
        .banner-container {
            min-width: 728px;
        }
    }
</style>
